// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function abc(): string {
    return 'abc';
}
